import axios from 'axios';

// 用相对路径（同源走 nginx 反代），不依赖 NEXT_PUBLIC_* env
// （Next.js 在 build 时把 NEXT_PUBLIC_* 字面量替换，运行时改 env 无效；同源最稳）
const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
});

// Auto refresh access token on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // /auth/login / /auth/login/send-code / /auth/register / /auth/forgot-password / /auth/reset-password
    // 没 refresh token cookie,refresh 必失败,跳过避免无意义的 refresh 请求
    // /auth/me 不在 skipRefresh:让 interceptor 帮它自动 refresh + retry
    // (refresh 失败时 originalRequest._retry 防循环)
    const skipRefresh = [
      '/auth/login',
      '/auth/login/send-code',
      '/auth/register',
      '/auth/forgot-password',
      '/auth/reset-password',
    ].some((p) => originalRequest.url === p || originalRequest.url?.startsWith(p + '?'));
    if (error.response?.status === 401 && !originalRequest._retry && !skipRefresh) {
      originalRequest._retry = true;

      try {
        await axios.post('/api/auth/refresh', {}, { withCredentials: true });
        return api(originalRequest);
      } catch (e) {
        // Refresh failed — just reject, let calling code handle it
        console.error('Token refresh failed:', e);
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  },
);

export default api;
